import { HttpClient } from "../HttpClient";

export const GetTransactionById = async (transactionId, transactiontype, additionalParams = {}) => {
  try {
    console.log("🔍 GetTransactionById:", { transactionId, transactiontype, additionalParams });
    
    // Build query string manually
    let queryString = `transactionId=${transactionId}&transactiontype=${transactiontype}`;
    
    if (additionalParams.userId) {
      queryString += `&userId=${additionalParams.userId}`;
    }
    
    if (additionalParams.isImpersonation) {
      queryString += `&isImpersonation=${additionalParams.isImpersonation}`;
    }
    
    const url = `api/transactionHistory/by-transaction?${queryString}`;
    console.log("📡 GetTransactionById URL:", url);
    
    const { data } = await HttpClient.get(url);
    console.log("✅ GetTransactionById response:", data);
    return await Promise.resolve(data);
  } catch (err) {
    console.error("❌ GetTransactionById error:", err);
    return Promise.reject(err);
  }
};
// export const GetTransactionById = async (transactionId, transactiontype) => {
//   try {
//     const { data } = await HttpClient.get(
//       `api/transactionHistory/by-transaction?transactionId=${transactionId}&transactiontype=${transactiontype}`
//     );
//     return await Promise.resolve(data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
